<script setup lang="ts">
import router from '@/router'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useCreateInflowSourceDefinitionMutation } from './SettingsPageLineActivationInflowSourceView.generated'
import SettingPageLineActivationInflowSourceForm, {
  type InflowSourceDefinitionForm,
} from './SettingPageLineActivationInflowSourceForm.vue'

const form = {
  inflowSourceName: '',
  useShortenedURL: false,
}

const { mutate } = useCreateInflowSourceDefinitionMutation()

const save = async (v: InflowSourceDefinitionForm) => {
  await mutate({
    input: {
      inflowSourceName: v.inflowSourceName,
      useShortenedURL: v.useShortenedURL,
    },
  })

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'LineActivationSettingInflowSource' })
}
</script>

<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>友だち追加経路 追加</template>
    </SettingsPagePanelHeader>
    <SettingPageLineActivationInflowSourceForm :form="form" @save="save" />
  </SettingsPagePanel>
</template>
